import { useEffect } from 'react';

/** Calls `handler` when the Escape key is pressed. The `keydown` listener is
 * only attached while `enabled` is true (typically the open state of a
 * menu/drawer/dialog) and is removed on cleanup. */
function useEscapeKey(handler, enabled = true) {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        handler(event);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [handler, enabled]);
}

export default useEscapeKey;
